import axios from 'axios';
import { AppSettings,Storage} from '../../configs';
import { authHeader } from '../../helpers/auth-header';

import {
    GET_MYTASK,
    GET_INPROGRESS,
    START_LOADING,
    STOP_LOADING,
    UPDATE_STATUS_TRANSACION,
    ERROR_401
} 
from '../actions/actionTypes';

export function getMyTaskAction(tabId, userId, userRole, userDepartment) {
    return function (dispatch) {
        
        dispatch({
            type : START_LOADING
          })

            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Mytask/GetMyTask`,
                params: {
                    tabId:tabId,
                    userId:userId,
                    userRole:userRole,
                    userDepartment:userDepartment
                }
            })
            
            promise.then(response => {
                dispatch({
                    type: GET_MYTASK,
                    payload: response.data,
                });

                dispatch({
                    type: STOP_LOADING
                })
            }
            ).catch(error=>{    
                dispatch({
                    type: STOP_LOADING
                })

                if(error.message && error.message.indexOf("code 401")!=-1){
                    window.emitter.emit(ERROR_401)
                }
            })

            return promise
    }
}

export function getInProgressAction(tabId, userId, userRole, userDepartment) {
    return function (dispatch) {
        try {
            let promise= axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Mytask/GetMyTask`,
                params: {
                    tabId:tabId,
                    userId:userId,
                    userRole:userRole,
                    userDepartment:userDepartment
                }
            })
            
            promise.then(response => {
                dispatch({
                    type: GET_INPROGRESS,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) {

        } finally {
        }
    }
}

export function updateStatusAction(updateStatusArr) {
    
    return function (dispatch) {

        dispatch({
            type: START_LOADING
        })

        try {
            let promise = axios({
                headers: authHeader(),
                method: "post",
                url: `${AppSettings.apiUrl}/api/Mytask/MyTaskUpdateStatus`,
                data: updateStatusArr
               
            })

            promise.then(response => {
                dispatch({
                    type: UPDATE_STATUS_TRANSACION,
                    payload: response.data,
                });
                dispatch({
                    type: STOP_LOADING
                });
            }
            );

            return promise
        } catch (error) {
            dispatch({
                type: STOP_LOADING
            })

        } finally {
        }
    }
}